import { gate } from 'hub-http/gates';
// v3 gates - https://product.hubteam.com/docs/gating/next-gen/usage.html#frontend-usage

export const HUBSPOT_CREDITS_PAGE_V2 = gate('SSM:PricingPageV2:HubSpotCreditsV2');
export const TRI_TEMPORARY_DISCOUNT = gate('TRI::TemporaryDiscount');
export const EMEA_HSFM_PROMO_BANNER = gate('EMEAHSfMPromoBanner');
export const EMEA_HSFM_PROMO_BANNER_OVERFLOW = gate('EMEAHSfMPromoBannerOverflow');